import { useState, useMemo } from 'react';
import { Card, Table, Input, Badge } from '@nexora/design-system';

interface NcmEntry {
  code: string;
  description: string;
  category: string;
}

const NCM_DATA: NcmEntry[] = [
  // ANIMAIS VIVOS E PRODUTOS DO REINO ANIMAL
  { code: '0101', description: 'Cavalos, asnos, mulas e bardotos, vivos', category: 'Reino Animal' },
  { code: '0201', description: 'Carnes de animais da espécie bovina, frescas ou refrigeradas', category: 'Reino Animal' },
  { code: '0301', description: 'Peixes vivos', category: 'Reino Animal' },
  { code: '0401', description: 'Leite e nata, não concentrados nem adicionados de açúcar', category: 'Reino Animal' },

  // PRODUTOS VEGETAIS
  { code: '0701', description: 'Batatas (sementes), frescas ou refrigeradas', category: 'Produtos Vegetais' },
  { code: '0801', description: 'Cocos, castanhas do Pará e castanhas de caju, frescos', category: 'Produtos Vegetais' },
  { code: '0901', description: 'Café, mesmo torrado ou descafeinado', category: 'Produtos Vegetais' },
  { code: '1001', description: 'Trigo e centeio', category: 'Produtos Vegetais' },
  { code: '1201', description: 'Soja, mesmo triturada', category: 'Produtos Vegetais' },

  // GORDURAS E ÓLEOS
  { code: '1501', description: 'Gorduras de porco e de aves', category: 'Gorduras e Óleos' },
  { code: '1507', description: 'Óleo de soja e suas frações', category: 'Gorduras e Óleos' },

  // PRODUTOS ALIMENTARES E BEBIDAS
  { code: '1701', description: 'Açúcares de cana ou de beterraba', category: 'Alimentos e Bebidas' },
  { code: '1801', description: 'Cacau inteiro ou partido, em bruto ou torrado', category: 'Alimentos e Bebidas' },
  { code: '2001', description: 'Preparações de hortaliças, frutas e partes de plantas', category: 'Alimentos e Bebidas' },
  { code: '2101', description: 'Extratos, essências e concentrados de café', category: 'Alimentos e Bebidas' },
  { code: '2201', description: 'Águas minerais e gaseificadas', category: 'Alimentos e Bebidas' },
  { code: '2401', description: 'Tabaco não manufaturado', category: 'Alimentos e Bebidas' },

  // PRODUTOS MINERAIS
  { code: '2501', description: 'Sal (incluindo sal de mesa)', category: 'Produtos Minerais' },
  { code: '2601', description: 'Minérios de ferro e seus concentrados', category: 'Produtos Minerais' },
  { code: '2701', description: 'Hulhas; briquetes e bolas combustíveis', category: 'Produtos Minerais' },
  { code: '2710', description: 'Óleos de petróleo ou de minerais betuminosos', category: 'Produtos Minerais' },

  // PRODUTOS QUÍMICOS
  { code: '2801', description: 'Flúor, cloro, bromo e iodo', category: 'Produtos Químicos' },
  { code: '2901', description: 'Hidrocarbonetos acíclicos', category: 'Produtos Químicos' },
  { code: '3001', description: 'Glândulas e outros órgãos para usos terapêuticos', category: 'Produtos Químicos' },
  { code: '3002', description: 'Sangue humano; vacinas', category: 'Produtos Químicos' },
  { code: '3101', description: 'Adubos (fertilizantes) de origem animal ou vegetal', category: 'Produtos Químicos' },
  { code: '3201', description: 'Extratos tanantes de origem vegetal', category: 'Produtos Químicos' },
  { code: '3301', description: 'Óleos essenciais', category: 'Produtos Químicos' },
  { code: '3401', description: 'Sabões e preparações para lavar', category: 'Produtos Químicos' },
  { code: '3501', description: 'Caseínas, caseinatos e outros derivados', category: 'Produtos Químicos' },
  { code: '3601', description: 'Pólvoras e explosivos', category: 'Produtos Químicos' },
  { code: '3701', description: 'Produtos químicos para fotografia', category: 'Produtos Químicos' },
  { code: '3801', description: 'Grafita artificial; preparações para extintores', category: 'Produtos Químicos' },

  // PLÁSTICOS E BORRACHA
  { code: '3901', description: 'Polímeros de etileno, em formas primárias', category: 'Plásticos e Borracha' },
  { code: '3920', description: 'Outras chapas, folhas, películas de plástico', category: 'Plásticos e Borracha' },
  { code: '4001', description: 'Borracha natural, mesmo vulcanizada', category: 'Plásticos e Borracha' },
  { code: '4011', description: 'Pneumáticos novos de borracha', category: 'Plásticos e Borracha' },

  // COURO, PELES, MADEIRA
  { code: '4101', description: 'Couros e peles em bruto', category: 'Couro, Madeira e Papel' },
  { code: '4201', description: 'Artefatos de couro; artigos de viagem', category: 'Couro, Madeira e Papel' },
  { code: '4401', description: 'Lenha; madeira em estilhas ou partículas', category: 'Couro, Madeira e Papel' },
  { code: '4403', description: 'Madeira em bruto', category: 'Couro, Madeira e Papel' },
  { code: '4801', description: 'Papel jornal, em bobinas ou folhas', category: 'Couro, Madeira e Papel' },
  { code: '4802', description: 'Papel e cartão para escrita ou impressão', category: 'Couro, Madeira e Papel' },

  // TÊXTEIS E CALÇADOS
  { code: '5101', description: 'Lã não cardada nem penteada', category: 'Têxteis e Calçados' },
  { code: '5201', description: 'Algodão não cardado nem penteado', category: 'Têxteis e Calçados' },
  { code: '5401', description: 'Fios de filamentos sintéticos', category: 'Têxteis e Calçados' },
  { code: '6101', description: 'Casacos, blusões e capas, de malha (uso masculino)', category: 'Têxteis e Calçados' },
  { code: '6201', description: 'Casacos, blusões e capas (uso masculino, não malha)', category: 'Têxteis e Calçados' },
  { code: '6401', description: 'Calçados com sola de borracha ou plástico', category: 'Têxteis e Calçados' },
  { code: '6403', description: 'Calçados com sola de couro natural', category: 'Têxteis e Calçados' },

  // METAIS COMUNS
  { code: '7101', description: 'Pérolas naturais ou cultivadas', category: 'Metais e Pedras Preciosas' },
  { code: '7108', description: 'Ouro (incluindo ouro platinado)', category: 'Metais e Pedras Preciosas' },
  { code: '7201', description: 'Ferro fundido bruto e ferro spiegel', category: 'Metais Comuns' },
  { code: '7208', description: 'Produtos laminados planos de ferro ou aço', category: 'Metais Comuns' },
  { code: '7301', description: 'Perfis de ferro ou aço', category: 'Metais Comuns' },
  { code: '7401', description: 'Cobre para refinação', category: 'Metais Comuns' },
  { code: '7403', description: 'Cobre refinado e ligas de cobre', category: 'Metais Comuns' },
  { code: '7601', description: 'Alumínio em formas brutas', category: 'Metais Comuns' },

  // MÁQUINAS E EQUIPAMENTOS
  { code: '8401', description: 'Reatores nucleares; elementos combustíveis', category: 'Máquinas' },
  { code: '8413', description: 'Bombas para líquidos', category: 'Máquinas' },
  { code: '8418', description: 'Refrigeradores e congeladores', category: 'Máquinas' },
  { code: '8421', description: 'Centrifugadores e aparelhos para filtrar', category: 'Máquinas' },
  { code: '8443', description: 'Máquinas de impressão', category: 'Máquinas' },
  { code: '8450', description: 'Máquinas de lavar roupa', category: 'Máquinas' },
  { code: '8471', description: 'Computadores e unidades de memória', category: 'Máquinas' },
  { code: '8473', description: 'Partes de máquinas de escritório', category: 'Máquinas' },
  { code: '8481', description: 'Torneiras, válvulas e dispositivos semelhantes', category: 'Máquinas' },
  { code: '8501', description: 'Motores e geradores elétricos', category: 'Máquinas' },
  { code: '8517', description: 'Aparelhos telefônicos e de comunicação', category: 'Máquinas' },
  { code: '8523', description: 'Discos, fitas e outros suportes para gravação', category: 'Máquinas' },
  { code: '8528', description: 'Monitores e televisores', category: 'Máquinas' },
  { code: '8536', description: 'Aparelhos para interrupção e proteção elétrica', category: 'Máquinas' },
  { code: '8541', description: 'Diodos, transistores e semicondutores', category: 'Máquinas' },

  // VEÍCULOS
  { code: '8701', description: 'Tratores', category: 'Veículos' },
  { code: '8703', description: 'Automóveis de passageiros', category: 'Veículos' },
  { code: '8704', description: 'Veículos para transporte de mercadorias', category: 'Veículos' },
  { code: '8711', description: 'Motocicletas', category: 'Veículos' },
  { code: '8712', description: 'Bicicletas e outros ciclos', category: 'Veículos' },
  { code: '8802', description: 'Aeronaves e veículos espaciais', category: 'Veículos' },

  // INSTRUMENTOS DE PRECISÃO
  { code: '9001', description: 'Fibras ópticas e feixes de fibras ópticas', category: 'Instrumentos' },
  { code: '9018', description: 'Instrumentos e aparelhos para medicina', category: 'Instrumentos' },
  { code: '9021', description: 'Instrumentos para correção auditiva ou ortopedia', category: 'Instrumentos' },
  { code: '9030', description: 'Osciloscópios e aparelhos para medidas elétricas', category: 'Instrumentos' },
  { code: '9101', description: 'Relógios de pulso e de bolso', category: 'Instrumentos' },

  // ARMAS E MUNIÇÕES
  { code: '9301', description: 'Armas de guerra', category: 'Armas' },
  { code: '9302', description: 'Revolveres e pistolas', category: 'Armas' },

  // MÓVEIS, BRINQUEDOS, DIVERSOS
  { code: '9401', description: 'Assentos (móveis para sentar)', category: 'Móveis e Diversos' },
  { code: '9403', description: 'Móveis de madeira', category: 'Móveis e Diversos' },
  { code: '9404', description: 'Suportes para colchões e artefatos de cama', category: 'Móveis e Diversos' },
  { code: '9501', description: 'Brinquedos de rodeio ou de feira', category: 'Móveis e Diversos' },
  { code: '9503', description: 'Triciclos, patinetes e carros para crianças', category: 'Móveis e Diversos' },
  { code: '9504', description: 'Jogos de vídeo e aparelhos de jogos', category: 'Móveis e Diversos' },
  { code: '9601', description: 'Marfim trabalhado e suas obras', category: 'Móveis e Diversos' },
  { code: '9619', description: 'Absorventes e fraldas', category: 'Móveis e Diversos' },
];

export function NcmTablePage(): JSX.Element {
  const [search, setSearch] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('ALL');

  // Extract unique categories
  const categories = useMemo(() =>
    ['ALL', ...new Set(NCM_DATA.map(c => c.category))],
    []
  );

  const filtered = useMemo(() => {
    let data = NCM_DATA;
    if (categoryFilter !== 'ALL') {
      data = data.filter(c => c.category === categoryFilter);
    }
    if (search) {
      const q = search.toLowerCase();
      data = data.filter(c =>
        c.code.includes(q) || c.description.toLowerCase().includes(q)
      );
    }
    return data;
  }, [search, categoryFilter]);

  const columns = [
    { header: 'Código NCM', accessor: 'code' as const, render: (v: string) => <code style={{ fontWeight: 600 }}>{v}</code> },
    { header: 'Descrição', accessor: 'description' as const },
    { header: 'Categoria', accessor: 'category' as const, render: (v: string) => <Badge variant="info">{v}</Badge> },
  ];

  return (
    <div className="fiscal-page">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-md mb-lg">
        <div>
          <h1 className="font-display-lg text-display-lg text-on-surface m-0">Tabela NCM</h1>
          <p className="font-body-md text-body-md text-on-surface-variant mt-xs">Nomenclatura Comum do Mercosul.</p>
        </div>
        <div className="flex flex-wrap items-center gap-sm">
          <p style={{ color: '#43474e', fontSize: '0.875rem' }}>Nomenclatura Comum do Mercosul</p>
        </div>
      </div>
      <Card>
        <div className="filters">
          <Input placeholder="Buscar por código ou descrição..." value={search} onChange={e => setSearch(e.target.value)} />
          <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} style={{ padding: '0.5rem', borderRadius: 4, border: '1px solid #c4c6cf' }}>
            <option value="ALL">Todas as categorias</option>
            {categories.filter(c => c !== 'ALL').map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <Table columns={columns} data={filtered} emptyMessage="Nenhum NCM encontrado" />
      </Card>
      <style>{`
        .fiscal-page { padding: 1.5rem; }
        .filters { display: flex; gap: 1rem; margin-bottom: 1rem; }
        .filters > *:first-child { flex: 1; }
      `}</style>
    </div>
  );
}
